module.exports = __webpack_public_path__ + "img/drying_rack.067fd41f.png";